import type { BackendTypes } from '@tf/api';
import { TFNotifier } from '@tf/ui';
import type React from 'react';
import type { ManagersFilterFn } from '@/components/shared';
import { AssignedManagersSelect } from '@/components/shared';
import { useSetPaymentAssigneesMutation } from '@/core/api/payments';

interface Props {
	paymentId: string;
	selectedIds: string[];
	managers: BackendTypes.UserInfo[];
	managersFilter?: ManagersFilterFn;
}

export const AssignedPaymentManagersWidget: React.FC<Props> = ({
	paymentId,
	selectedIds,
	managers,
	managersFilter,
}) => {
	const setAssigneesMutation = useSetPaymentAssigneesMutation();

	const onChange = (selectedManagers: string[]) => {
		setAssigneesMutation.mutate(
			{ paymentId: paymentId, assignees: selectedManagers },
			{
				onSuccess: () => {
					TFNotifier.info('Assigned managers for payment updated', { id: 'assign-manager' });
				},
				onError: () => {
					TFNotifier.error('Error while updating assignees');
				},
			},
		);
	};

	return (
		<AssignedManagersSelect
			selectedIds={selectedIds}
			managers={managers}
			managersFilter={managersFilter}
			onChange={onChange}
		/>
	);
};
